module.exports = __webpack_public_path__ + "media/images/icon_menu-50f8bcc2c07ee9adf2c67655a7023783.svg";